export async function loadViggo() {
  // 4/14/23: something changed recently in the toolchain involving
  // the building of the viggo NPM package and its subsequent loading in webpack.
  // I haven't succeeded in pinpointing the precise cause, but this workaround
  // has been successful. Apparently, however things have changed, webpack ends
  // up doing the right thing for us when we explicitly do a dynamic import
  // like this, rather than using the static import style at the tops of consuming
  // modules.
  //
  // So code that uses viggo should do it like this:
  //
  // 1. statically import *this* function:
  //
  // import { loadViggo } from 'app/viggo'
  //
  // 2. then, in some async function, do this:
  //
  // const viggo = await loadViggo()
  //
  // For now, static importing like this no longer works:
  //
  // import { SvgImportMessageKind, SvgImportMessageCode } from '@fortawesome-internal-tools/viggo
  //
  // The actual problem this solves is that the wasm file itself is not be loaded
  // without this workaround. So at runtime, you get an error like this in the JS console:
  //
  // instrument.js:108 TypeError: Cannot read properties of undefined (reading '__wbindgen_add_to_stack_pointer')
  return await import('@fortawesome-internal-tools/viggo')
}
